module.exports = __webpack_public_path__ + "img/payroll-confirm-img.f5073305.png";